// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__UcoA_","dragIcon":"Choice_dragIcon__33hQW","left":"Choice_left__3G3TI","input":"Choice_input__-du86"};